export class VForm {
	addZformRow(parent, name) {
		console.log(parent);
		let maxRows = $(parent).closest('.form-tbl').attr('data-max');
		if (maxRows)
		{
			let countRows = $(parent).closest('table').find('tbody tr').length;
			if (countRows >= maxRows)
			{
				$(parent).closest('.form-item').find('>.form-item__top .form-item__mistake').text('Максимальное число элементов ' + maxRows).show();
				return ;
			}
		}

		var template = document.getElementById(name.replace(/_ids(\[[\w_\d]+\])?/, '') + '_tpl').innerHTML;
		var maxEl = document.getElementById(name.replace(/_ids(\[[\w_\d]+\])?/, '') + '_max_id');
		maxEl.value++;
		var jsId = maxEl.value;

		//var qwe = '#' + name + '_js_id_name#';


		var html = new String(template + '<td><input type="hidden" name="' + name + '[]" value="add_' + jsId + '" /><div class="table__actions"><ul class="table__actions-list"><li class="table__actions-item"><button class="table__actions-btn" type="button" onclick="vform.delZformRow(this);"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 16C2 14.8954 2.81757 14 3.82609 14H28.1739C29.1824 14 30 14.8954 30 16C30 17.1046 29.1824 18 28.1739 18H3.82609C2.81757 18 2 17.1046 2 16Z" fill="#002D80"></path></svg></button></li><li class="table__actions-item"><button class="table__actions-btn" type="button" onclick="vform.addZformRow(this, \'' + name + '\');"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 2C17.0085 2 17.8261 2.81757 17.8261 3.82609V14.1739H28.1739C29.1824 14.1739 30 14.9915 30 16C30 17.0085 29.1824 17.8261 28.1739 17.8261H17.8261V28.1739C17.8261 29.1824 17.0085 30 16 30C14.9915 30 14.1739 29.1824 14.1739 28.1739V17.8261H3.82609C2.81757 17.8261 2 17.0085 2 16C2 14.9915 2.81757 14.1739 3.82609 14.1739H14.1739V3.82609C14.1739 2.81757 14.9915 2 16 2Z" fill="#002D80"></path></svg></button></li></ul></div></td>');
		html = html.replace(/\[__js_replace__\]/g, '[add_' + jsId + ']');

		var tr = $('<tr>' + html + '</tr>');


		var el = $(parent).closest('thead, tboby');
		var pEl = $(parent).closest('thead, tboby');

		if (pEl.prop("tagName") == 'THEAD') {
			pEl.closest('table').find('>tbody').prepend(tr);
		}
		else {
			tr.insertAfter($(parent).closest('tr'));
		}

		this.applyEvents(tr);

		//var slt = tr.find('.slt_ajax');
		//applySltAjax(slt);

		return tr;
	}

	delZformRow(parent) {
		console.log(parent);
		let maxRows = $(parent).closest('.form-tbl').attr('data-max');
		if (maxRows)
		{
			let countRows = $(parent).closest('table').find('tbody tr').length;
			if (countRows <= maxRows + 1)
			{
				$(parent).closest('.form-item').find('>.form-item__top .form-item__mistake').text('').hide();
			}
		}

		$(parent).closest('tr').remove();
	}

	toggleRows(name, parent) {
		$('input[type=checkbox][name^=' + name + ']').prop('checked', $(parent).prop('checked'))
	}

	applyEvents(el = null) {
		let _this = this;

		if (el == null)
			el = $(document);

		// Range slider
		el.find('.form-slider').each(function () {
			let block = this;
			const rangeInput = block.querySelectorAll(".form-slider__range-input"),
				priceInput = block.querySelectorAll(".form-slider__input"),
				range = block.querySelector(".form-slider__progress");
			let priceGap = priceInput[0].getAttribute('step');

			priceInput.forEach(input => {
				let min = parseInt(input.getAttribute("data-min"), 10) || 0;
				let max = parseInt(input.getAttribute("data-max"), 10) || 0;
				input.addEventListener("input", (e) => {
					input.value = Number(input.value.replace(/\D/g, ''), 10).toLocaleString('ru-RU');

					let minPrice = parseInt(priceInput[0].value.replace(/\D/g, '')),
						maxPrice = parseInt(priceInput[1].value.replace(/\D/g, ''));

					if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
						if (e.target.classList.contains("form-slider__input--min")) {
							rangeInput[0].value = minPrice;
							range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
						} else {
							rangeInput[1].value = maxPrice;
							range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
						}
					}
				});
				input.addEventListener("blur", (e) => {
					let value = parseInt(input.value.replace(/\s/g, ''), 10) || min;
					input.value = value;
					input.value = Number(input.value.replace(/\D/g, ''), 10).toLocaleString('ru-RU');

					if (value < min) {
						input.value = parseInt(input.getAttribute("data-min").replace(/\D/g, ''), 10).toLocaleString('ru-RU');
					}
					if (value > max) {
						input.value = parseInt(input.getAttribute("data-max").replace(/\D/g, ''), 10).toLocaleString('ru-RU');
					}

					let minPrice = parseInt(priceInput[0].value.replace(/\D/g, '')),
						maxPrice = parseInt(priceInput[1].value.replace(/\D/g, ''));

					if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
						if (e.target.className === "form-slider__input--min") {
							rangeInput[0].value = minPrice;
							range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
						} else {
							rangeInput[1].value = maxPrice;
							range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
						}
					}
				});
			});

			rangeInput.forEach(input => {
				input.addEventListener("input", (e) => {
					let minVal = parseInt(rangeInput[0].value),
						maxVal = parseInt(rangeInput[1].value);

					if ((maxVal - minVal) < priceGap) {
						if (e.target.classList.contains("form-slider__range-input--min")) {
							rangeInput[0].value = maxVal - priceGap
						} else {
							rangeInput[1].value = minVal + priceGap;
						}
					} else {
						priceInput[0].value = minVal;
						priceInput[1].value = maxVal;
						range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
						range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";

						priceInput.forEach(input => {
							input.value = Number(input.value.replace(/\D/g, '')).toLocaleString('ru-RU');
						});
					}
				});
			});

			var event = new Event('input', {
				bubbles: true,
				cancelable: true,
			});

			rangeInput[0].dispatchEvent(event);
		});


		// form multi
		el.find(".form-multi__top-input").on("focusin", function (e) {
			let el = $(this);
			$(".form-multi__top-input").removeClass("active");
			$(".form-multi__choice").removeClass("active");
			el.addClass("active")
			el.parent(".form-multi__top").siblings(".form-multi__choice").addClass("active");
			setTimeout(function () { el.closest(".form-multi").find(".form-multi__search-input").focus() }, 200);
			e.preventDefault();
		});

		// form multi radio
		el.find(".form-multi__choice-input[type='radio']").on("change", function () {
			$(this).closest(".form-multi").find(".form-multi__top-input").val($(this).siblings(".form-multi__choice-label").text());
			$(".form-multi__top-input").removeClass("active");
			$(".form-multi__choice").removeClass("active");
		});

		// form multi check
		el.find(".form-multi__choice-input[type='checkbox']").on("change", function () {
			if ($(this).closest(".form-multi").find(".form-multi__choice-input:checked").length > 0) {
				$(".form-multi__result").show();
			} else {
				$(".form-multi__result").hide();
			}

			if ($(this).is(":checked")) {
				$(this).closest(".form-multi").find(".form-multi__result-list").append('<li class="form-multi__result-item"><button class="form-multi__result-remove" type="button" data-id="' + $(this).attr("id") + '"><span>' + $(this).siblings(".form-multi__choice-label").text() + '</span><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M13.7903 2C13.2291 2 12.7742 2.46445 12.7742 3.03736V4.07472H7.01613C6.45494 4.07472 6 4.53917 6 5.11209C6 5.685 6.45494 6.14945 7.01613 6.14945H25.9839C26.545 6.14945 27 5.685 27 5.11209C27 4.53917 26.545 4.07472 25.9839 4.07472H20.2258V3.03736C20.2258 2.46445 19.7709 2 19.2097 2H13.7903Z" fill="#002D80"></path><path d="M17.9371 19.6352L19.9281 21.668C20.325 22.0731 20.325 22.7298 19.9281 23.1349C19.5313 23.5401 18.888 23.5401 18.4912 23.1349L16.5 21.1023L14.5088 23.1349C14.112 23.5401 13.4686 23.5401 13.0718 23.1349C12.675 22.7298 12.675 22.0731 13.0718 21.668L15.0629 19.6352L13.0718 17.6023C12.675 17.1972 12.675 16.5405 13.0718 16.1354C13.4686 15.7303 14.112 15.7303 14.5088 16.1354L16.5 18.1681L18.4912 16.1354C18.888 15.7303 19.5313 15.7303 19.9281 16.1354C20.325 16.5405 20.325 17.1972 19.9281 17.6023L17.9371 19.6352Z" fill="#002D80"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.35934 9.83856C8.41653 9.3132 8.8515 8.91575 9.36927 8.91575H23.6308C24.1485 8.91575 24.5835 9.3132 24.6407 9.83856L24.9118 12.3301C25.4033 16.8465 25.4033 21.4046 24.9118 25.921L24.8851 26.1664C24.69 27.9591 23.3289 29.3887 21.5792 29.6388C18.2095 30.1204 14.7905 30.1204 11.4208 29.6388C9.67099 29.3887 8.31 27.9591 8.11488 26.1664L8.08819 25.921C7.59662 21.4046 7.59662 16.8465 8.08819 12.3301L8.35934 9.83856ZM10.2787 10.9905L10.108 12.5592C9.63303 16.9234 9.63303 21.3279 10.108 25.692L10.1347 25.9372C10.2272 26.7874 10.8727 27.4654 11.7026 27.5841C14.8853 28.0389 18.1147 28.0389 21.2973 27.5841C22.1273 27.4654 22.7728 26.7874 22.8653 25.9372L22.892 25.692C23.367 21.3279 23.367 16.9234 22.892 12.5592L22.7213 10.9905H10.2787Z" fill="#002D80"></path></svg></button></li>');
			} else {
				$(".form-multi__result-remove[data-id='" + $(this).attr("id") + "']").closest(".form-multi__result-item").remove();
			}

			$(this).closest(".form-multi").find(".form-multi__search-input").val('').trigger('input').focus();
		});

		el.find('.form-multi__choice .form-multi__search-input').on('input', function () {
			let el = $(this);
			let text = el.val();
			let list = el.closest('.form-multi__choice').find('.form-multi__choice-list');
			list.find('li').each(function () {
				let name = $(this).find('label').text();
				if (name.toLowerCase().indexOf(text.toLowerCase()) != -1) {
					$(this).show();
				}
				else {
					$(this).fadeOut();
				}
			});
		});

		el.find(".form-multi__result").on("click", ".form-multi__result-remove", function (e) {
			let block = $(this).closest('.form-multi');
			e.stopPropagation();
			$(this).parent(".form-multi__result-item").remove();
			block.find(".form-multi__choice-list .form-multi__choice-input[id='" + $(this).attr("data-id") + "']").prop('checked', false).trigger('change');
		});

		// Аякс выбор в селекте
		el.find('.form-multi__search-input').on('input', function () {
			let el = $(this);
			let table = $(this).attr('data-table');
			if (table) {
				let text = el.val();
				let list = el.closest('.form-multi__choice').find('.form-multi__choice-list');
				$.ajax({
					type: "POST",
					url: '/vsop/ajax/search/',
					dataType: 'json',
					data: { table: table, text: text },
					success: function (data) {
						list.html('');
						let id, name;
						for (let i = 0; i < data.result.length; i++) {
							id = data.result[i].id;
							name = data.result[i].name;
							list.append(`<li class="form-multi__choice-item">
								<input class="form-multi__choice-input visually-hidden" type="radio" name="${table}" id="${table}_${id}" value="${id}">
								<label class="form-multi__choice-label" for="${table}_${id}">${name}</label>
							</li>`);
						}

						list.find(".form-multi__choice-input[type='radio']").on("change", function () {
							$(this).closest(".form-multi").find(".form-multi__top-input").val($(this).siblings(".form-multi__choice-label").text());
							$(".form-multi__top-input").removeClass("active");
							$(".form-multi__choice").removeClass("active");
						});
					},
					error: function (e) {
						alert(e);
					}
				});
			}
		});

		// Добавление файла
		el.find('.form-file__input').on('change', function () {
			let list = $(this).closest('.form-item__main');
			if (this.files.length) {
				list.find('.files-results__list').html('');
				for (let i = 0; i < this.files.length; i++)
				{
					let name = this.files[i].name;
					list.find('.files-results__list').append(`<li class="files-results__item"><button class="files-results__button" type="button"><span>${name}</span></button></li>`);
				}
			}
			else {
				list.find('.files-results__list').html('');
			}
		});

		// Перенести!
		const Russian = require("flatpickr/dist/l10n/ru.js").default.ru;

		// flatpickrs date simple
		flatpickr(el.find(".form-date__input--simple"), {
			dateFormat: "d.m.Y",
			"locale": Russian,
		});

		// flatpickrs date simple
		flatpickr(el.find(".form-datetime__input--simple"), {
			enableTime: true,
			dateFormat: "d.m.Y H:i",
			minDate: new Date(),
			time_24hr: true,
			"locale": Russian,
		});

		// flatpickrs date multiple
		flatpickr(el.find(".form-date__input--multiple"), {
			mode: "multiple",
			dateFormat: "d.m.Y",
			"locale": Russian,
		});

		// flatpickrs date range
		flatpickr(el.find(".form-date__input--range"), {
			mode: "range",
			dateFormat: "d.m.Y",
			"locale": Russian,
		});

		// flatpickrs time simple
		flatpickr(el.find(".form-time__input--simple"), {
			enableTime: true,
			noCalendar: true,
			dateFormat: "H:i",
			time_24hr: true,
			"locale": Russian,
		});

		// textarea autoheight
		el.find(".form-textarea--autoheight").each(function () {
			this.style.height = 'auto';
			this.style.height = (this.scrollHeight) + 2 + 'px';
		});
		el.find('.form-textarea--autoheight').on('input', function () {
			this.style.height = 'auto';
			this.style.height = (this.scrollHeight) + 2 + 'px';
		});

		// tinymce
		tinymce.init({
			selector: (".form-mce:visible"), //el.find не работает
			relative_urls: false,
			skin: false,
			content_css: false,
			content_style: 'body { font-family: "Nunito", Arial, "Helvetica Neue", Helvetica, sans-serif }',
			language: "ru",
			language_url: "/vsop/ru.js",
			plugins: 'advlist lists image media link table code file-manager',
			menubar: false,
			toolbar: 'undo redo | bold italic underline strikethrough | styles | bullist numlist | image media link | table | code',
			toolbar_mode: 'sliding',
		});

		el.find(".table__navigation-btn--move").click(function() {
			let ids = $('.table tbody .form-check input[name^=table_ids]').serialize();
			_this.loadItemMove(ids);
		});

		el.find(".table__navigation-btn--delete").click(function() {
			if (confirm('Вы уверены?'))
			{
				let ids = $('.table tbody .form-check input[name^=table_ids]').serialize();
				_this.deleteItems(ids);
			}
		});
	}

	loadForm(table, id, pid, mid, parent)
	{
		let _this = this;
		if (!mid)
		{
			let url = new URL(window.location.href);
			mid = url.searchParams.get('selected_mod_id');
		}
		let popup = $('.popup[data-popup-name=popup-form]');

		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + mid + '/',
			dataType: 'html',
			data: {action: 'loadForm', table: table, id: id, mid: mid},
			success: function(res)
			{
				popup.find('.card').html(res);
				popup.addClass("active");
				$("body").addClass("no-scroll");
				_this.applyEvents(popup.find('form'));
				popup.find('form').submit(function(){
					_this.submitAjaxForm(table, id, pid, mid, this, parent);
					return false;
				});
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	submitAjaxForm(table, id, pid, mid, parent, grandParent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + mid + '/',
			dataType: 'json',
			data: $(parent).serialize() + '&id=' + id + '&pid=' + pid + '&action=ajaxSubmit&table=' + table,
			success: function(res)
			{
				if (res.success)
				{
					$(parent).html('<h2>Успешно!</h2>');
					
					if ($(grandParent).hasClass('form-multi__add-new'))
					{
						let list = $(grandParent).closest('ul');
						let name = res.name;
						id = res.last;
						list.append(`<li class="form-multi__choice-item">
								<input class="form-multi__choice-input visually-hidden" type="radio" name="slt_${table}" id="slt_${table}_${id}" value="${id}" checked>
								<label class="form-multi__choice-label" for="slt_${table}_${id}">${name}</label>
							</li>`);
						list.closest(".form-multi").find(".form-multi__top-input").val(name);
							
					}
					else if ($(grandParent).hasClass('form-multi__edit-row'))
					{
						let item = $(grandParent).closest('.form-item');
						let name = res.name;
						
						item.find('.form-multi__choice-input').closest('li').find('label').text(name);
						item.find(".form-multi__top-input").val(name);
					}
					else
					{
						if (id)
						{
							_this.updateTableRow($(grandParent).closest('tr'), res.data);
						}
						else
						{
							location.reload();
						}
					}
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	addNewInSelect(field, table, pid, mid, parent)
	{
		let _this = this;
		let popup = $('.popup[data-popup-name=popup-form]');

		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + mid + '/',
			dataType: 'html',
			data: {action: 'loadForm', table: table, id: 0, mid: mid},
			success: function(res)
			{
				popup.find('.card').html(res);
				popup.addClass("active");
				$("body").addClass("no-scroll");
				popup.find('form').submit(function(){
					_this.submitAddInSelect(field, table, pid, mid, this, parent);
					return false;
				});
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	submitAddInSelect(field, table, pid, mid, parent, grandParent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/' + mid + '/',
			dataType: 'json',
			data: $(parent).serialize() + '&pid=' + pid + '&action=ajaxSubmit&table=' + table,
			success: function(res)
			{
				if (res.success)
				{
					let ul = $(grandParent).closest('.form-multi__choice').find('ul');
					let li = ul.find('.form-multi__choice-item--add-new').prepend('<li class="form-multi__choice-item"><input class="form-multi__choice-input visually-hidden" type="radio" name="' + field + '" id="' + field + '_id' + res.last +  '" value="' + res.last +  '"><label class="form-multi__choice-label" for="' + field + '_id' + res.last +  '">' + res.data[1] +  '</label></li>');
					li.find('input').prop('checked', true).on("change", function () {
						$(this).closest(".form-multi").find(".form-multi__top-input").val($(this).siblings(".form-multi__choice-label").text());
						$(".form-multi__top-input").removeClass("active");
						$(".form-multi__choice").removeClass("active");
					}).trigger('change');
					$(parent).html('<h2>Успешно!</h2>');
					
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	ajaxDelete(table, id, mid, parent)
	{
		let _this = this;
		if (!mid)
		{
			let url = new URL(window.location.href);
			mid = url.searchParams.get('selected_mod_id');
		}

		if (confirm('Вы уверены?'))
		{
			$.ajax({
				type: "POST",
				url: '/vsop/ajax/' + mid + '/',
				dataType: 'json',
				data: {action: 'ajaxDelete', table: table, id: id, mid: mid},
				success: function(res)
				{
					if (res.success)
					{
						$(parent).closest('tr').fadeOut(function(){$(this).remove()});
					}
					else
					{
						alert(res.error);
					}
				},
				error: function(e)
				{
					alert(e);
				}
			});
		}
	}

	updateTableRow(tr, data)
	{
		for (const [i, value] of Object.entries(data)) {
			tr.find('td[data-field = ' + i.toLowerCase() + ']').text(value);
		}
	}

	addZformLi(parent, name) {
		console.log(parent);
		let maxRows = $(parent).closest('.form-item').attr('data-max');
		if (maxRows)
		{
			let countRows = $(parent).closest('.form-item').find('ul.photos-results__list li').length;
			if (countRows >= maxRows)
			{
				$(parent).closest('.form-item').find('>.form-item__top .form-item__mistake').text('Максимальное число элементов ' + maxRows).show();
				return ;
			}
		}

		var template = document.getElementById(name.replace(/_ids(\[[\w_\d]+\])?/, '') + '_tpl').innerHTML;
		var maxEl = document.getElementById(name.replace(/_ids(\[[\w_\d]+\])?/, '') + '_max_id');
		maxEl.value++;
		var jsId = maxEl.value;

		var html = new String(template + '<input type="hidden" name="' + name + '_ids[]" value="add_' + jsId + '" />');
		html = html.replace(/\[__js_replace__\]/g, '[add_' + jsId + ']');

		var li = $('<li class="photos-results__item">' + html + '</li>');

		$(parent).closest('.form-item').find('.photos-results__list').append(li)

		this.applyEvents(li);

		return li;
	}

	delZformLi(parent) {
		console.log(parent);
		let maxRows = $(parent).closest('.form-item').attr('data-max');
		if (maxRows)
		{
			let countRows = $(parent).closest('.form-item').find('ul.photos-results__list li').length;
			if (countRows <= maxRows + 1)
			{
				$(parent).closest('.form-item').find('>.form-item__top .form-item__mistake').text('').hide();
			}
		}

		$(parent).closest('li').remove();
	}

	captureFiles(files, parent, mid = null)
	{
		if(parent.closest('.form-file').find('input').prop('multiple'))
		{
			if (mid)
				var url = '/ajax.php?mid=' + mid + '&action=put_file';
			else
				var url = '/vsop/ajax/images/?action=put_file';
			
			for (var i = 0; i < files.length; i++)
			{
				var file = files[i];
				if (file.type.match(/image.*/)) 
				{
					var li = this.addZformLi(parent, parent.closest('.form-file').attr('data-name'));
					
					if (li)
					{
						li.append('<div class="loader"></div>');
						
						var reader = new FileReader();
						reader.onload = (function(aImg) {
							return function(e) {
								aImg.attr('src', e.target.result);
								/* ... обновляем инфу о выбранных файлах ... */
							};
						})(li.find('img'));
			      		reader.readAsDataURL(file);
						
						this.uploadFile(file, url, li);
					}
				}     
			}
		}
		else
		{
			let name = parent.find('input').attr('name');
			let li = $(parent).closest(".form-item__main").find(".photos-results__list").html('<li class="photos-results__item"><input class="files-results__input visually-hidden" type="checkbox" name="del_' + name + '" id="del_' + name + '"><label class="photos-results__item-button photos-results__item-button--remove" for="del_' + name + '"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M13.7903 2C13.2291 2 12.7742 2.46445 12.7742 3.03736V4.07472H7.01613C6.45494 4.07472 6 4.53917 6 5.11209C6 5.685 6.45494 6.14945 7.01613 6.14945H25.9839C26.545 6.14945 27 5.685 27 5.11209C27 4.53917 26.545 4.07472 25.9839 4.07472H20.2258V3.03736C20.2258 2.46445 19.7709 2 19.2097 2H13.7903Z" fill="#002D80"></path><path d="M17.9371 19.6352L19.9281 21.668C20.325 22.0731 20.325 22.7298 19.9281 23.1349C19.5313 23.5401 18.888 23.5401 18.4912 23.1349L16.5 21.1023L14.5088 23.1349C14.112 23.5401 13.4686 23.5401 13.0718 23.1349C12.675 22.7298 12.675 22.0731 13.0718 21.668L15.0629 19.6352L13.0718 17.6023C12.675 17.1972 12.675 16.5405 13.0718 16.1354C13.4686 15.7303 14.112 15.7303 14.5088 16.1354L16.5 18.1681L18.4912 16.1354C18.888 15.7303 19.5313 15.7303 19.9281 16.1354C20.325 16.5405 20.325 17.1972 19.9281 17.6023L17.9371 19.6352Z" fill="#002D80"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.35934 9.83856C8.41653 9.3132 8.8515 8.91575 9.36927 8.91575H23.6308C24.1485 8.91575 24.5835 9.3132 24.6407 9.83856L24.9118 12.3301C25.4033 16.8465 25.4033 21.4046 24.9118 25.921L24.8851 26.1664C24.69 27.9591 23.3289 29.3887 21.5792 29.6388C18.2095 30.1204 14.7905 30.1204 11.4208 29.6388C9.67099 29.3887 8.31 27.9591 8.11488 26.1664L8.08819 25.921C7.59662 21.4046 7.59662 16.8465 8.08819 12.3301L8.35934 9.83856ZM10.2787 10.9905L10.108 12.5592C9.63303 16.9234 9.63303 21.3279 10.108 25.692L10.1347 25.9372C10.2272 26.7874 10.8727 27.4654 11.7026 27.5841C14.8853 28.0389 18.1147 28.0389 21.2973 27.5841C22.1273 27.4654 22.7728 26.7874 22.8653 25.9372L22.892 25.692C23.367 21.3279 23.367 16.9234 22.892 12.5592L22.7213 10.9905H10.2787Z" fill="#002D80"></path></svg></label><div class="photos-results__item-image-wrapper"><div class="photos-results__item-image-container"><img class="photos-results__item-image" src="" alt=""></div></div></li>');
			console.log(li);
			var reader = new FileReader();
			reader.onload = (function(aImg) {
				return function(e) {
					aImg.attr('src', e.target.result);
				};
			})(li.find('img'));
      		reader.readAsDataURL(files[0]);
		}
	}

	uploadFile(file, url, el) {
	  
	  var reader = new FileReader();
	 
	  reader.onload = function() {    
	    var xhr = new XMLHttpRequest();    
	    
		xhr.upload.addEventListener("progress", function(e) {
			if (e.lengthComputable) {
				var progress = (e.loaded * 100) / e.total;
				/* ... обновляем инфу о процессе загрузки ... */
				$(el).find('a.adv_img_a .hold').css('width', (100-progress) + '%');
			}
		}, false);
	    
	    /* ... можно обрабатывать еще события load и error объекта xhr.upload ... */
	 
		xhr.onreadystatechange = function () {
			if (this.readyState == 4) {
				if(this.status == 200) {
					/* ... все ок! смотрим в this.responseText ... */
					//alert(this.responseText);
					var res = $.parseJSON(this.responseText);
					
					el.find('input, select').attr('disabled', false);
					el.find('.loader').remove();
					el.find('input[name*=img_img]').val(res.filename);
					el.find('input[name*=str_name]').val(res.name);
				} else {
					/* ... ошибка! ... */
				}
			}
		};
	    
	    xhr.open("POST", url);
	   
	   
	   	var formData = new FormData();
	   	formData.append('myFile', file);
	   	xhr.send(formData);
	  };
	  // Читаем файл
	  reader.readAsBinaryString(file);
	}

	loadItemMove(ids)
	{
		let url = new URL(window.location.href);
		let mid = url.searchParams.get('selected_mod_id');

		$.ajax({
			url: "/vsop/ajax/" + mid + "/",
			type: 'POST',
			data: ids + '&action=getMoveInfo',
			dataType: "html",
			success: function(res){
				$('.popup.popup-move .popup__container').replaceWith($(res).find('.popup__container'));

				$("body").addClass("no-scroll");
				$(".popup-move").addClass("active");
			},
			error: function(res, text){
				console.log(res);
				console.log(text);
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	moveItems(parent)
	{
		let url = new URL(window.location.href);
		let mid = url.searchParams.get('selected_mod_id');

		let form = $(parent);
		$.ajax({
			url: "/vsop/ajax/" + mid + "/",
			type: 'POST',
			data: form.serialize() + '&action=moveItems',
			dataType: "json",
			success: function(res){
				if (res.success)
				{
					form.html('<h1 class="success">Товары перенесены</h1>');
					location.href = '/vsop/modules/?selected_mod_id=' + mid + '&tree_id=' + res.rubric;
				}
			},
			error: function(res, text){
				console.log(res);
				console.log(text);
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	deleteItems(ids)
	{
		let url = new URL(window.location.href);
		let mid = url.searchParams.get('selected_mod_id');

		$.ajax({
			url: "/vsop/ajax/" + mid + "/",
			type: 'POST',
			data: ids + '&action=deleteItems',
			dataType: "json",
			success: function(res){
				if (res.success)
				{
					location.reload();
				}
			},
			error: function(res, text){
				console.log(res);
				console.log(text);
				alert('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}
}
